import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#0B2F2A] text-emerald-100/90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h2 className="text-white font-bold text-lg mb-3">
              <span>personalfinance</span><span className="text-[#FCD34D]">care.com</span>
            </h2>
            <p className="text-sm leading-relaxed text-emerald-100/90">Professional subscription management and after-sales support you can trust.</p>
          </div>

          {/*
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><FiMail className="w-4 h-4 text-[#FCD34D]" /> <span className="text-emerald-100/90">support@personalfinancecare.com</span></li>
            </ul>
          </div>
          */}

          <div className="md:col-start-3">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-[#FCD34D] text-emerald-100/90 transition-colors">Home</a></li>
              <li><a href="/faqs/" className="hover:text-[#FCD34D] text-emerald-100/90 transition-colors">FAQs</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-slate-300">
          &copy; 2026 personalfinancecare.com - All rights reserved.
        </div>
      </div>
    </footer>
  );
}
